import Vue from 'vue';

import Button from './Button.vue';
import Dialog from './Dialog.vue';
import Dropdown from './Dropdown.vue';
import DropdownItem from './DropdownItem.vue';
import Select from './Select.vue';
import Input from './Input.vue';
import Toggle from './Toggle.vue';
import Textarea from './Textarea.vue';

Vue.component('AlButton', Button);
Vue.component('AlDialog', Dialog);
Vue.component('AlDropdown', Dropdown);
Vue.component('AlDropdownItem', DropdownItem);
Vue.component('AlSelect', Select);
Vue.component('AlInput', Input);
Vue.component('AlToggle', Toggle);
Vue.component('AlTextarea', Textarea);
